module.exports = __webpack_public_path__ + "static/media/icon_arrow-right.67aeace0.svg";